import { Component, Input, OnInit } from '@angular/core';
import { PageDto } from 'src/app/data/models/dto/arrival/page.dto';
import { OccasionEligibleUserDto } from 'src/app/data/models/dto/occasion-eligible-user.dto';
import { OccasionUsersParamsDto } from 'src/app/data/models/dto/occasion-users-params.dto';
import { NewsAuthorizationStatusEnum } from 'src/app/data/models/enum/news-authorization-status.enum';
import { News } from 'src/app/data/models/interfaces/news';
import { NewsService } from 'src/app/data/services/news.service';
import { OccasionUsersService } from 'src/app/data/services/occasion-users.service';
import { ProfileService } from 'src/app/data/services/profile.service';
import { ProfilesNameSeparetedByComma } from 'src/app/data/utils/profile.utils';

@Component({
  selector: 'app-news-engagement-list',
  templateUrl: './news-engagement-list.component.html',
  styleUrls: ['./news-engagement-list.component.scss'],
})
export class NewsEngagementListComponent implements OnInit {
  @Input() news: News | undefined;
  //scroll
  throttle = 50;
  scrollDistance = 1;
  scrollUpDistance = 2;
  disableScrollFetch = false;
  //pagination
  params: OccasionUsersParamsDto = { page: 1, limit: 10 };
  //filters
  yearFilter: string = '';
  classroomsFilter: string[] = [];
  statusFilter: string[] = [];

  eligibleUsers: OccasionEligibleUserDto[] = [];
  countRegister?: number;
  newsHasAuthorization = false;
  isStudentProfileEligible: boolean = false;
  isResponsibleProfileEligible: boolean = false;
  canLoadAuthorizationStatusFilter: boolean = false;

  constructor(
    private occasionUsersService: OccasionUsersService,
    private newsService: NewsService,
    private profileService: ProfileService
  ) {}

  async ngOnInit(): Promise<void> {
    if (this.news) {
      this.yearFilter = this.news.year;
      this.newsHasAuthorization = this.news.hasAuthorization ?? false;
      this.canLoadAuthorizationStatusFilter = true;
      this.verifyProfileInEligibles(this.news);
      const result = await this.getFiltered(this.news.id!, this.params);
      this.addItems(result.data);
    }
  }

  async getFiltered(
    idOccasion: string,
    params?: OccasionUsersParamsDto
  ): Promise<PageDto<OccasionEligibleUserDto>> {
    const resp = await this.occasionUsersService
      .getAll(idOccasion, params)
      .toPromise();
    this.countRegister = resp.total;
    return resp;
  }

  private addItems(items: OccasionEligibleUserDto[]) {
    this.eligibleUsers.push(...items);
  }

  async onScrollDown(ev: any) {
    if (!this.disableScrollFetch) {
      this.params.page! += 1;
      const result = await this.getFiltered(this.news!.id!, this.params);
      this.addItems(result.data);
    }
  }

  async handleSelectClassroom(ids: string[]) {
    this.classroomsFilter = ids;
    this.params.page = 1;
    this.params.idsClassRooms = ids;
    const result = await this.getFiltered(this.news!.id!, this.params);
    this.eligibleUsers = result.data;
  }

  async handleSelectAuthorizationStatus(authorizationStatus: string[]) {
    this.statusFilter = authorizationStatus;
    this.params.visualized = undefined;
    this.params.authorized = undefined;
    this.params.notAuthorized = undefined;
    this.params.authorizationPending = undefined;
    authorizationStatus.forEach((status) => {
      const statusKey = Object.entries(NewsAuthorizationStatusEnum).find(
        ([key, val]) => val === status
      )?.[0];
      switch (status) {
        case NewsAuthorizationStatusEnum.AUTHORIZATION_PENDING:
          this.params.authorizationPending = true;
          break;
        case NewsAuthorizationStatusEnum.AUTHORIZED:
          this.params.authorized = true;
          break;
        case NewsAuthorizationStatusEnum.NOT_AUTHORIZED:
          this.params.notAuthorized = true;
          break;
        case NewsAuthorizationStatusEnum.VISUALIZED:
          if (this.params.visualized == undefined)
            this.params.visualized = true;
          else this.params.visualized = undefined;
          break;
        case NewsAuthorizationStatusEnum.NOT_VISUALIZED:
          if (this.params.visualized == undefined)
            this.params.visualized = false;
          else this.params.visualized = undefined;
          break;
      }
    });

    this.params.page = 1;
    const result = await this.getFiltered(this.news!.id!, this.params);
    this.eligibleUsers = result.data;
  }

  async handleSearchText(text: string) {
    this.params.page = 1;
    this.params.name = text;
    const result = await this.getFiltered(this.news!.id!, this.params);
    this.eligibleUsers = result.data;
  }

  async verifyProfileInEligibles(news: News) {
    let profilesNews = '';
    const profiles = await this.profileService.getAll().toPromise();
    if (news && news.idsProfiles) {
      profilesNews = ProfilesNameSeparetedByComma(profiles, news.idsProfiles);
    }

    this.isStudentProfileEligible = profilesNews.includes('Aluno');
    this.isResponsibleProfileEligible = profilesNews.includes('Responsável');
  }
}
